export default __webpack_public_path__ + "locales/pl/Webhooks.json?hash=47a75b81a10e712c4f49fac6df7777d1";